import Toolbar from "./Toolbar";
import {ToolbarItemFactory} from "./ToolbarItemFactory";

export function buildToolbar(items: string[][], tc: Toolbar, factory: ToolbarItemFactory) {

    items.forEach(group => {
        tc.addGroup(
            ...group.map(item => {
                return factory.create(item);
            })
        );
    });

}

export function basicToolbar(tc: Toolbar, factory: ToolbarItemFactory) {
    tc.addGroup(
        factory.create('undo'),
        factory.create('redo')
    );

    tc.addGroup(
        factory.create('bold'),
        factory.create('italic'),
        factory.create('underline'),
        factory.create('strike'),
        factory.create('clear-style')
    );

    tc.addGroup(
        factory.create('link')
    );

    tc.addGroup(
        factory.create('align-left'),
        factory.create('align-center'),
        factory.create('align-right'),
        factory.create('align-justify')
    );
}

export function fullToolbar(tc: Toolbar, factory: ToolbarItemFactory) {
    tc.addGroup(
        factory.create('undo'),
        factory.create('redo')
    );

    tc.addGroup(
        factory.create('block-formats')
    );

    tc.addGroup(
        factory.create('bold'),
        factory.create('italic'),
        factory.create('underline'),
        factory.create('strike'),
        factory.create('clear-style')
    );

    tc.addGroup(
        factory.create('link')
    );

    tc.addGroup(
        factory.create('bullet-list'),
        factory.create('ordered-list'),
    );

    tc.addGroup(
        factory.create('align-left'),
        factory.create('align-center'),
        factory.create('align-right'),
        factory.create('align-justify')
    );

    tc.addGroup(
        factory.create('image'),
        factory.create('image-float')
    )

    tc.addGroup(
        factory.create('youtube')
    )

    tc.addGroup(
        factory.create('table')
    );

    // tc.addGroup(
    //     factory.create('ai-generator')
    // )
}